import styled from "styled-components";
import colors from "../../constants/colors";

export const BackLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  background: none;
  border: none;
  padding: 0.5rem 0;
  margin: 0 0 0.5rem;
  color: ${colors.PURPLE};
  font-size: 0.9rem;
  cursor: pointer;
  align-self: flex-start;
`;
